// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"7a5a3fbb","683":"c8227bb5","787":"80f9befc"}[chunkId] + ".chunk.js";
};